import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Phone, MapPin, Lock, Camera, Save, Package, Heart, LogOut, Edit2, Plus, Trash2 } from 'lucide-react';
import Header from './components/Header3';
import Footer from './components/Footer3';

const Profile3 = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        fullName: 'Ananya Sharma', email: 'ananya.sharma@example.com', phone: '+91 98765 43210',
        avatar: 'https://ui-avatars.com/api/?name=Ananya+Sharma&size=200&background=722F37&color=FFFFFF&font-size=0.4',
        address: { street: '45 Heritage Lane', city: 'Jaipur', state: 'Rajasthan', pincode: '302001' },
        bio: 'Connoisseur of fine Indian couture and handcrafted textiles.',
    });

    const [addresses, setAddresses] = useState([
        { id: 1, label: 'Home', name: 'Ananya Sharma', street: '45 Heritage Lane, Bandra West', city: 'Mumbai', state: 'Maharashtra', pincode: '400050', phone: '+91 98765 43210', isDefault: true },
        { id: 2, label: 'Office', name: 'Ananya Sharma', street: '12 Business Park, Lower Parel', city: 'Mumbai', state: 'Maharashtra', pincode: '400013', phone: '+91 98765 43210', isDefault: false },
    ]);

    const tabs = [
        { id: 'profile', label: 'Profile', icon: User },
        { id: 'addresses', label: 'Addresses', icon: MapPin },
        { id: 'orders', label: 'Orders', icon: Package },
    ];

    const inputBaseClass = "w-full px-4 py-3.5 bg-[#FFFFFF] border border-[#E8E0D8] text-[#1A1A1A] text-sm outline-none transition-colors duration-300 focus:border-[#722F37] placeholder-[#9CA3AF]";

    return (
        <>
            <style>{`@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Lato:wght@300;400;700&display=swap');`}</style>
            <div style={{ fontFamily: "'Lato', sans-serif" }} className="min-h-screen bg-[#FFFDF7]">
                <Header />
                <main className="pt-24 pb-16 px-4 lg:px-8">
                    <div className="max-w-[1000px] mx-auto">
                        <div className="mb-10">
                            <p className="text-[#B8860B] text-xs font-bold tracking-[0.3em] uppercase mb-3">Your Account</p>
                            <h1 style={{ fontFamily: "'Playfair Display', serif" }} className="text-3xl lg:text-4xl font-bold text-[#722F37]">My Profile</h1>
                        </div>

                        {/* Tabs */}
                        <div className="flex gap-1 mb-8" style={{ borderBottom: '1px solid #E8E0D8' }}>
                            {tabs.map(tab => (
                                <button key={tab.id} onClick={() => setActiveTab(tab.id)} className="flex items-center gap-2 px-4 py-3 text-sm font-bold transition-all" style={{
                                    color: activeTab === tab.id ? '#722F37' : '#6B7280',
                                    borderBottom: activeTab === tab.id ? '2px solid #722F37' : '2px solid transparent',
                                }}>
                                    <tab.icon size={16} /> {tab.label}
                                </button>
                            ))}
                        </div>

                        {/* Profile Tab */}
                        {activeTab === 'profile' && (
                            <div className="p-6" style={{ backgroundColor: '#FFFFFF', border: '1px solid #E8E0D8' }}>
                                <div className="flex items-center gap-6 mb-8">
                                    <div className="relative">
                                        <img src={profileData.avatar} alt="Profile" className="w-20 h-20 rounded-full object-cover" style={{ border: '3px solid #722F37' }} />
                                        <button className="absolute -bottom-1 -right-1 w-8 h-8 rounded-full flex items-center justify-center" style={{ backgroundColor: '#722F37', color: '#FFFFFF' }}>
                                            <Camera size={14} />
                                        </button>
                                    </div>
                                    <div>
                                        <h2 className="text-lg font-bold" style={{ color: '#1A1A1A' }}>{profileData.fullName}</h2>
                                        <p className="text-sm italic" style={{ color: '#6B7280' }}>{profileData.bio}</p>
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                        <div><label className="block text-sm font-bold text-[#1A1A1A] mb-1">Full Name</label><input value={profileData.fullName} readOnly={!isEditing} className={inputBaseClass} /></div>
                                        <div><label className="block text-sm font-bold text-[#1A1A1A] mb-1">Email</label><input value={profileData.email} readOnly className={`${inputBaseClass} bg-[#FFF9F0]`} /></div>
                                    </div>
                                    <div><label className="block text-sm font-bold text-[#1A1A1A] mb-1">Phone</label><input value={profileData.phone} readOnly={!isEditing} className={inputBaseClass} /></div>
                                </div>

                                <div className="flex gap-3 mt-6">
                                    {isEditing ? (
                                        <>
                                            <button onClick={() => setIsEditing(false)} className="inline-flex items-center gap-2 px-6 py-3 text-sm font-bold tracking-wider uppercase" style={{ backgroundColor: '#722F37', color: '#FFFFFF' }}>
                                                <Save size={16} /> Save Changes
                                            </button>
                                            <button onClick={() => setIsEditing(false)} className="px-6 py-3 text-sm font-bold tracking-wider uppercase" style={{ border: '1px solid #E8E0D8', color: '#6B7280' }}>Cancel</button>
                                        </>
                                    ) : (
                                        <button onClick={() => setIsEditing(true)} className="inline-flex items-center gap-2 px-6 py-3 text-sm font-bold tracking-wider uppercase" style={{ border: '1px solid #722F37', color: '#722F37' }}>
                                            <Edit2 size={16} /> Edit Profile
                                        </button>
                                    )}
                                </div>

                                <div className="mt-8 pt-6" style={{ borderTop: '1px solid #E8E0D8' }}>
                                    <button onClick={() => navigate('/template3/login')} className="inline-flex items-center gap-2 text-sm font-bold" style={{ color: '#722F37' }}>
                                        <LogOut size={16} /> Sign Out
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Addresses Tab */}
                        {activeTab === 'addresses' && (
                            <div className="space-y-4">
                                {addresses.map(addr => (
                                    <div key={addr.id} className="p-4 lg:p-6 flex justify-between" style={{ backgroundColor: '#FFFFFF', border: `1px solid ${addr.isDefault ? '#722F37' : '#E8E0D8'}` }}>
                                        <div>
                                            <div className="flex items-center gap-2 mb-2">
                                                <span className="text-sm font-bold" style={{ color: '#1A1A1A' }}>{addr.label}</span>
                                                {addr.isDefault && <span className="text-[10px] font-bold px-2 py-0.5 uppercase" style={{ backgroundColor: '#722F37', color: '#FFFFFF' }}>Default</span>}
                                            </div>
                                            <p className="text-sm" style={{ color: '#1A1A1A' }}>{addr.name}</p>
                                            <p className="text-sm" style={{ color: '#6B7280' }}>{addr.street}, {addr.city}, {addr.state} {addr.pincode}</p>
                                            <p className="text-sm" style={{ color: '#6B7280' }}>{addr.phone}</p>
                                        </div>
                                        <div className="flex gap-2">
                                            <button className="p-2 transition-colors" style={{ color: '#6B7280' }}><Edit2 size={16} /></button>
                                            <button className="p-2 transition-colors" style={{ color: '#6B7280' }}><Trash2 size={16} /></button>
                                        </div>
                                    </div>
                                ))}
                                <button className="inline-flex items-center gap-2 px-6 py-3 text-sm font-bold tracking-wider uppercase" style={{ border: '1px solid #722F37', color: '#722F37' }}>
                                    <Plus size={16} /> Add New Address
                                </button>
                            </div>
                        )}

                        {/* Orders Tab */}
                        {activeTab === 'orders' && (
                            <div className="text-center py-12">
                                <p className="text-sm mb-4" style={{ color: '#6B7280' }}>View and manage all your orders</p>
                                <button onClick={() => navigate('/template3/orders')} className="inline-flex items-center gap-2 px-6 py-3 text-sm font-bold tracking-wider uppercase" style={{ backgroundColor: '#722F37', color: '#FFFFFF' }}>
                                    <Package size={16} /> View All Orders
                                </button>
                            </div>
                        )}
                    </div>
                </main>
                <Footer />
            </div>
        </>
    );
};

export default Profile3;
